import Vue from 'vue'

import store from './q-components/q-store';

import './assets/css'

import router from './router'

import icon from './assets/images/fav.png';
import app from './app.vue'

import {library} from '@fortawesome/fontawesome-svg-core'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {fas} from '@fortawesome/free-solid-svg-icons'
import {fab} from '@fortawesome/free-brands-svg-icons'

import './q-elements'
import './q-core'
import './q-components/index'


Vue.prototype.$super = function (options) {
  return new Proxy(options, {
    get: (options, name) => {
      if (options.methods && name in options.methods) {
        return options.methods[name].bind(this);
      }
    },
  });
};

library.add(fas);
library.add(fab);
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.prototype.$store = store;

if (typeof (module.hot) !== 'undefined') { // eslint-disable-line no-undef
  module.hot.accept() // eslint-disable-line no-undef
}


router.afterEach((to, from) => {
  //AMIN
  if (to === from)
    console.log('am');
  store.state.loader = false;
});

router.beforeEach((to, from, next) => {
  store.state.loader = true;
  next();
});

Vue.config.productionTip = false; //AMIN
Vue.prototype.$eventHub = new Vue(); // Global event bus

window.vm = new Vue({
  el: '#app',
  components: {app},
  data: {
    pageTitle: 'Qasedak Console'
  },
  created() {
    setFavIcon();
    document.title = this.pageTitle;
  },
  router,
  store,
  template: '<app/>'
});

function setFavIcon() {
  let link = document.querySelector("link[rel*='icon']") || document.createElement('link');
  link.type = 'image/x-icon';
  link.rel = 'shortcut icon';
  link.href = icon;
  document.getElementsByTagName('head')[0].appendChild(link);
}
